import { useEffect } from 'react';

import { useCurrentPartner } from 'services/repositories/partners/partners';
import { setIssueResolver } from 'stores/webedi/webedi';

import { IssueResolverType, PartnerDTO } from '../support/types';

export function useIssueResolver(resolverID: string | null | undefined): IssueResolverType {
  const { data: currentPartner } = useCurrentPartner();

  const resolverType = getResolverType(resolverID, currentPartner);

  useEffect(() => {
    setIssueResolver(resolverType);
  }, [resolverType]);

  return resolverType;
}

const getResolverType = (
  resolverID: string | null | undefined,
  currentPartner: PartnerDTO | undefined,
): IssueResolverType => {
  if (!resolverID || !currentPartner) {
    return IssueResolverType.PROCUROS;
  }

  const isCurrentPartner = resolverID === currentPartner.id;
  return isCurrentPartner ? IssueResolverType.CURRENT_PARTNER : IssueResolverType.OTHER_PARTNER;
};

useIssueResolver.getResolverType = getResolverType;
